import { render, staticRenderFns } from "./MyAsk.vue?vue&type=template&id=52570e35&"
import script from "./MyAsk.vue?vue&type=script&lang=js&"
export * from "./MyAsk.vue?vue&type=script&lang=js&"
import style0 from "./MyAsk.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports